import { beMessGetMessageDetails } from 'Api/BeMessApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'
import {
  beEmailCheckupCheckSpam,
  beEmailCheckupEOACheck
} from 'Api/beEmailCheckupApi'

export async function getMessageDetails(idMessage) {
  const {
    IdMessage: id,
    MessageType: messageType,
    IsBee: isBee,
    Subject: subject
  } = await beMessGetMessageDetails(idMessage)

  return { id, messageType, isBee, subject }
}

export async function isSendingMessage(idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}

export const formatReport = s => {
  return s
    .replace(/(<br[^>]*>)/gi, '{linebreak}')
    .replace(/(\u003cBR\u003e)/gi, '{linebreak}')
}

export async function getSpamCheck(idMessage) {
  const result = await beEmailCheckupCheckSpam(idMessage)
  return result
}

export async function getDeliverabilityCheck(idMessage) {
  const result = await beEmailCheckupEOACheck(idMessage)
  return result
}
